<template>
    <div class="row report-row">
        <div class="col-md-12">
            <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>

            <card v-else >
                <template slot="header">
                    <div class="clearfix">
                        <div class="float-left">
                            <strong>Reports</strong>
                            <p>Rows Selected: {{registrations.length}}</p>
                            <p>Filters Applied: {{ filterTotal.length }}</p>
                        </div>

                        <!-- <el-button
                            v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].downloadReports)"
                            class="btn btn-primary"
                            :loading="downloading"
                            @click="downloadReports()">
                                Downlaod
                                <fa icon="download"/>
                        </el-button> -->
                        <el-button
                            v-if="user.admin || (user.adminRoles && user.adminRoles[user._id] && user.adminRoles[user._id].downloadReports) || (user.roles && user.roles[eventId] && user.roles[eventId].downloadReports)"
                            class="btn btn-primary float-right"
                            :loading="downloading"
                            @click="downloadReports()">
                                Download
                                <fa icon="download"/>
                        </el-button>
                    </div>
                </template>
                <table class="table table-responsive custom table-striped text-center scrollable-table report-table">
                    <thead>
                        <tr>
                            <th style="min-width: 100px">
                                ID
                                <el-input
                                    v-model="filters.id"
                                    @keyup.native="filterRegistrations(true)"/>
                            </th>
                            <th style="min-width: 100px">
                                Confirmation Number
                                <el-input
                                    v-model="filters.confirmationNumber"
                                    @keyup.native="filterRegistrations(true)"/>
                            </th>
                            <th style="min-width: 180px">
                                Primary Registrant
                                <el-select
                                    v-model="filters.parent"
                                    @change="filterRegistrations(false)">
                                        <el-option :value="null" label="All"/>
                                        <el-option :value="1" label="Yes"/>
                                        <el-option :value="0" label="No"/>
                                </el-select>
                            </th>
                            <th style="min-width: 170px">
                                Status
                                <el-select
                                    multiple
                                    v-model="filters.status"
                                    @change="filterRegistrations(false)">
                                        <el-option value="all" label="All"/>
                                        <el-option value="confirmed" label="Confirmed"/>
                                        <el-option value="pending" label="Pending"/>
                                        <el-option value="rejected" label="Rejected"/>
                                        <el-option value="deleted" label="Deleted"/>
                                </el-select>
                            </th>
                            <th style="min-width: 170px">Group ID</th>
                            <th style="min-width: 170px">Registrants Count</th>
                            <th style="min-width: 170px">Unsatisfied Minimum Count</th>
                            <!-- <th style="min-width: 250px">Total Available Registrants Count</th> -->
                            <th style="min-width: 300px">
                                Registration Type
                                <el-select
                                    multiple
                                    v-model="filters.byRegistrantType"
                                    @change="filterRegistrations(false)">
                                        <!-- <el-option :value="null" label="All"/> -->
                                        <el-option
                                            v-for="(item, index) in getRegistrationTypeOptions"
                                            :key="`registration-type-${index}`"
                                            :value="item.value"
                                            :label="item.label">
                                            {{ item.label }}
                                        </el-option>
                                </el-select>
                            </th>
                            <th style="min-width: 170px">Registration Date</th>
                            <th style="min-width: 170px">Total Amount</th>
                            <th style="min-width: 170px">Paid Amount</th>
                            <th style="min-width: 170px">Due Amount</th>
                            <th style="min-width: 170px">Manual additional charges</th>
                            <th style="min-width: 170px">Manual Discounts</th>
                            <!-- <th style="min-width: 170px">
                                Payment Method
                                <el-select
                                    v-model="filters.paymentMethod"
                                    @change="filterRegistrations(false)">
                                        <el-option :value="null" label="All"/>
                                        <el-option value="check" label="Check"/>
                                        <el-option value="online" label="Online"/>
                                </el-select>
                            </th> -->
                            <th style="min-width: 170px">
                                Payment Status
                                <el-select
                                    v-model="filters.paymentStatus"
                                    @change="filterRegistrations(false)">
                                        <el-option :value="null" label="All"/>
                                        <el-option value="not_paid" label="Not Paid"/>
                                        <el-option value="partial_payment" label="Partial Payment"/>
                                        <el-option value="fully_paid" label="Fully Paid"/>
                                </el-select>
                            </th>
                            <!-- <th style="min-width: 170px">
                                Full or Partial Payment
                                <el-select
                                    v-model="filters.fullOrPartial"
                                    @change="filterRegistrations(false)">
                                        <el-option :value="null" label="All"/>
                                        <el-option value="full" label="Full"/>
                                        <el-option value="deposit" label="Partial"/>
                                </el-select>
                            </th> -->
                            <th style="min-width: 170px">
                                Some Payment Made
                                <el-select
                                    v-model="filters.paymentMade"
                                    @change="filterRegistrations(false)">
                                        <el-option :value="null" label="All"/>
                                        <el-option value="yes" label="Yes"/>
                                        <el-option value="no" label="No"/>
                                </el-select>
                            </th>
                            <th>Payments Made</th>
                            <th style="min-width: 170px">
                                Checked In
                                <el-select
                                    v-model="filters.checkedIn"
                                    @change="filterRegistrations(false)">
                                        <el-option :value="null" label="All"/>
                                        <el-option value="yes" label="Yes"/>
                                        <el-option value="no" label="No"/>
                                </el-select>
                            </th>
                            <th style="min-width: 170px">QR Code</th>
                            <th style="min-width: 170px">Created By</th>
                            <th style="min-width: 170px">Checked In By</th>
                            <th style="min-width: 170px">Checked In Time</th>
                            <th
                                v-for="(field, index) in Object.values(customFields)"
                                :key="`custom-field-title-${index}`"
                                style="min-width: 170px">
                                    {{ field.title }}
                            </th>
                            <th v-for="activity in activities">
                                {{activity.name}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="background-color: #0080003d;">
                            <th>Totals</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{ totals.unsatisfiedMinimumCount }}</td>
                            <td></td>
                            <td></td>
                            <td>${{ totals.net }}</td> 
                            <td>${{ totals.deposit }}</td>
                            <td>${{ totals.balance }}</td>
                            <td>${{ totals.charges }}</td>
                            <td>${{ totals.discounts }}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td
                                v-for="(field, index) in Object.keys(customFields)"
                                :key="`totals-${index}`"
                                style="min-width: 170px">
                                    {{ totals[field] }}
                            </td>
                            <td v-for="activity in activities">
                                {{ totals.activity[activity._id] }}
                            </td>
                        </tr>
                        <tr
                            v-for="registrant in registrations"
                            :key="`registration-${registrant._id}`">
                                <td>{{ registrant._id }}</td>
                                <td>{{ registrant.confirmationNumber }}</td>
                                <td>{{ registrant.parent ? 0 : 1 }}</td>
                                <td>{{ registrant.status }}</td>
                                <td>
                                    <span v-if="registrant.parent">
                                        {{ registrant.parent._id }}
                                    </span>
                                    <span v-else-if="isParent[registrant._id]">
                                        {{ registrant._id }}
                                    </span>
                                </td>
                                <!-- <td>{{ registrant.registrants.length?(registrant.registrants.length+1):(registrant.registrants.length==0 && registrant.parent==undefined?1:'') }}</td> -->
                                <td>{{registrant.registrantsCount? registrant.registrantsCount: ''}}</td>
                                <td>{{registrant.type.minimumCount && registrant.registrantsCount ? (registrant.type.minimumCount - registrant.registrantsCount > 0 ? registrant.type.minimumCount - registrant.registrantsCount : 0)  : ''}}</td>
                                <!-- <td>{{ registrant | avlRegistrantCount }}</td> -->
                                <td>{{ registrant.type.name }}</td>
                                <td>{{ registrant.createdAt | formatDate }}</td>
                                <td><span v-if="!registrant.parent">${{ parseInt(registrant.total) }}</span></td>
                                <td><span v-if="!registrant.parent">${{ parseInt(registrant.paid) }}</span></td>
                                <td><span v-if="!registrant.parent">${{ parseInt(registrant.total)-parseInt(registrant.paid) }}<!-- ${{ registrant | deposit }} --></span></td>
                                <td><span v-if="!registrant.parent">${{ registrant.totalCharges }}</span></td>
                                <td><span v-if="!registrant.parent">${{ registrant.totalDiscounts }}</span></td>
                                <!-- <td>{{ registrant.paymentMethod }}</td> -->
                                <td v-if="!registrant.parent">
                                    <span v-if="registrant.paid > 0 && registrant.paid < registrant.total ">Partial Payment</span>
                                    <span v-else-if="registrant.paid >= registrant.total">Fully Paid</span>
                                    <span v-else="registrant.paid == 0">Not Paid</span>
                                </td>
                                <td v-else>
                                    <span v-if="registrant.parent.paid > 0 && registrant.parent.paid < registrant.parent.total ">Partial Payment</span>
                                    <span v-else-if="registrant.parent.paid >= registrant.parent.total">Fully Paid</span>
                                    <span v-else="registrant.parent.paid == 0">Not Paid</span>
                                </td>
                                <td v-if="!registrant.parent">
                                    <span v-if="registrant.paid > 0 && registrant.paid < registrant.total ">Yes</span>
                                    <span v-else-if="registrant.paid >= registrant.total">Yes</span>
                                    <span v-else="registrant.paid == 0">No</span>
                                </td>
                                <td v-else>
                                    <span v-if="registrant.parent.paid > 0 && registrant.parent.paid < registrant.parent.total ">Yes</span>
                                    <span v-else-if="registrant.parent.paid >= registrant.parent.total">Yes</span>
                                    <span v-else="registrant.parent.paid == 0">No</span>
                                </td>
                                <!-- <td>{{ registrant.paymentType }}</td> -->
                                <!-- <td v-if="!registrant.parent">{{ registrant.paid > 0 ? 'Yes' : 'No' }}</td>
                                <td v-else>{{ registrant.parent.paid > 0 ? 'Yes' : 'No' }}</td> -->
                                <td>{{ registrant.paymentDes.join(' | ') }}</td>
                                <td>{{ registrant.checkedInDate && registrant.checkedInDate.length ? 'Yes' : 'No' }}</td>
                                <td>{{ registrant._id }}</td>
                                <td>{{ registrant.creator && registrant.creator.email ? registrant.creator.email: '' }}</td>
                                <td>{{ registrant.checkedInBy && registrant.checkedInBy.email ? registrant.checkedInBy.email: '' }}</td>
                                <td v-if="registrant.checkedInDate">{{ registrant.checkedInDate | formatDate }}</td><td v-else></td>
                                <td
                                    v-for="(field, index) in Object.keys(customFields)"
                                    :key="`registration-${registrant._id}-custom-field-value-${index}`"
                                    style="min-width: 170px">
                                        <span v-if="getMedia[field] && getMedia[field].registrationId == registrant._id">
                                            <a
                                                :href="getMedia[field].url"
                                                :download="getMedia[field].url"
                                                @click.prevent="download({ path: getMedia[field].path, name: getMedia[field].name  })">
                                                    {{ getMedia[field].name }}
                                            </a>
                                        </span>
                                        <span v-else-if="registrant.customFields[field] ">
                                            {{ registrant.customFields[field].value }}
                                        </span>
                                        
                                        <!-- <span v-else>{{customFields[field].name=='STATE'}}
                                            {{ registrant.parent.fields.filter(item=>{
                                                    return item.fieldMapping==customFields[field].name.toLowerCase()
                                                })[0][value]
                                            }}
                                        </span> -->
                                </td>
                                <td v-for="activity in activities">
                                    {{ [...registrant.registeredActivities,...registrant.fieldBasedActivities].map(activity=>activity._id).includes(activity._id)?1:0 }}
                                </td>
                        </tr>
                        <tr style="background-color: #0080003d;">
                            <th>Totals</th>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{ totals.unsatisfiedMinimumCount }}</td>
                            <td></td>
                            <td></td>
                            <td>${{ totals.net }}</td>
                            <td>${{ totals.deposit }}</td>
                            <td>${{ totals.balance }}</td>
                            <td>${{ totals.charges }}</td>
                            <td>${{ totals.discounts }}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td
                                v-for="(field, index) in Object.keys(customFields)"
                                :key="`totals-${index}`"
                                style="min-width: 170px">
                                    {{ totals[field] }}
                            </td>
                            <td v-for="activity in activities">
                                {{ totals.activity[activity._id] }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="total" class="row">
                    <div class="col-12 d-flex justify-content-end">
                        <el-pagination
                            background
                            layout="total, sizes, prev, pager, next, jumper"
                            @size-change="getRegistrations"
                            @current-change="getRegistrations"
                            :current-page.sync="page"
                            :total="total"
                            :page-size.sync="perPage"
                            :page-sizes="[50, 100, 200, 400, 500, 1000]">
                        </el-pagination>
                    </div>
                </div>
            </card>
        </div>
    </div>
</template>
<style>
.report-table {
       width: initial;
    overflow: visible !important;
}
.report-row .card .card-body {
    height:80vh;
    overflow-x: auto;
    overflow-y: auto;
}
</style>
<script>
import http from '../http.js'
import moment from 'moment'
import download from 'downloadjs'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: true,
            allRegistrations: [],
            registrations: [],
            customFields: {},
            totals: {},
            registrationTypes: {},
            downloading: false,
            isParent: {},
            total: 0,
            perPage: 50,
            page: 1,
            filters: {
                parent: null,
                id: '',
                confirmationNumber: '',
                status: ["all"],
                byRegistrantType: null,
                paymentMethod: null,
                paymentStatus: null,
                fullOrPartial: null,
                paymentMade: null
            },
            filterTotal: 0,
            eventId: null,
            activities: [],
            //fields: [],
        }
    },
    computed: {
        ...mapState([
            'user',
            'allUploadedFiles',
            'baseUrl'
        ]),

        getMedia(){
            let arr = [];
            this.allUploadedFiles.forEach(el=>{
                if(el.registrationId){
                    arr[el.fieldId] = {
                        url: this.baseUrl + el.path,
                        name: el.name,
                        path: el.path,
                        registrationId: el.registrationId
                    }
                }
            })
            

            return arr
        },
        getRegistrationTypeOptions () {
            const options = []
            Object.keys(this.registrationTypes).forEach(key =>{
                options.push({
                    value: key,
                    label: this.registrationTypes[key]
                })
            })
            return options
        }
    },
    mounted () {
        this.eventId = this.$route.params.eventId
        this.getRegistrations()
        
    },
    methods: {
        getRegistrations: async function () {
            // fetch all uploaded files
            await this.$store.dispatch('getAllUploadedFiles')
            const activitiesData = await http.get(`/api/activities`, {params: {filters:{eventId:this.$route.params.eventId}}} )
            const manualPayments = await http.get(`/api/payments-manual-transaction/${this.$route.params.eventId}` )
            this.activities = activitiesData.data.activities;
            this.loading = true
            try {
                const response = await http.get('/api/registrations?reports=true', {
                    params: {
                        select: 'confirmationNumber status createdAt total paid paymentMethod paymentType paid checkedInDate registrants fields._id fields.value fields.name fields.title fields.showTotalsOnReport fields.showCount fields.dependsOnFields fields.dependsOnValues creator.email checkedInBy.email',
                        filters: {
                            eventId: this.$route.params.eventId,
                            populateParent: { select: 'confirmationNumber paid total fields.fieldMapping fields.value' },
                            populateType: { select: 'name groupCount minimumCount' },
                            populateFieldBasedActivities: {select: 'name' },
                            populateRegisteredActivities: {select: 'name' },
                        },
                    }
                })
                this.total = response.data.total
                const registrations = response.data.registrations
                const registrationTypes = {}
                const customFields = {}
                const activities = {}
                registrations.forEach(registration => {
                    registration.createdAt = moment(registration.createdAt).format('YYYY-MM-DD HH:mm:ss')
                    let type = registration.parent ? registration.parent.type : registration.type
                    registrationTypes[type._id] = type.name

                    registration.customFields = {}
                    registration.fields.forEach(field => {
                        if (field.hideOnExport) {
                            return
                        }

                        // if(field.dependsOnFields!=undefined && field.dependsOnFields.length){
                        //     let aaa = field.dependsOnFields.map(dependsOnField=>{
                        //         return this.fields.filter(field=>{
                        //             if(dependsOnField==field._id)
                        //                 return field
                        //         })
                        //     })
                        //     console.log('@@aaa', aaa)
                        // }

                        customFields[field._id] = {
                            name: field.name,
                            title: field.title,
                        }
                        // type: field.type

                        registration.customFields[field._id] = field

                        // if(field.dependsOnFields!=undefined && field.dependsOnFields.length){
                        //     field.dependsOnFields.map(dependsOnField=>{
                        //         return this.fields.filter(field=>{
                        //             if(dependsOnField==field._id){console.log('@@field.name', field.name)
                        //                 return field
                        //             }
                        //         })[0]
                        //     })
                        // }
                    })
                    
                    if (!registration.parent) {//console.log('@@registration.confirmationNumber', registration.confirmationNumber)
                        registration.registrantsCount = registrations.filter(item=>item.confirmationNumber==registration.confirmationNumber).length
                        //registration.type.used = registrations.map( item=>{ } )//.reduce( (total, item)=>total+1)
                        //console.log('registration.type.used', registration.type.used)
                    }

                    if (registration.parent && registration.parent._id) {
                        this.$set(this.isParent, registration.parent._id, 'true')
                    }

                    registration.totalCharges = 0
                    registration.totalDiscounts = 0
                    registration.paymentDes = []
                    if (manualPayments && manualPayments.data && manualPayments.data.payment && manualPayments.data.payment.length) {
                        manualPayments.data.payment.map(item=>{
                            if(item.registration==registration._id) {
                                if(item.type == "charge")
                                    registration.totalCharges += item.amount
                                if(item.type == "discount")
                                    registration.totalDiscounts += item.amount
                                if (item.type == "payment" ) {
                                    registration.paymentDes.push(`[${moment(item.createdAt).format('YYYY-MM-DD HH:mm')}|${item.method}|${item.description}|${item.amount}${item.by?`|${item.by.email}`:''}]`)
                                }
                            }
                        })
                    }

                })

                this.registrationTypes = registrationTypes
                this.customFields = customFields

                this.allRegistrations = registrations
                //console.log('@@this.allRegistrations', this.allRegistrations)
                //console.log('@@memorySizeOf',this.memorySizeOf(this.allRegistrations))
                this.filterRegistrations()
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting data in reports')
            }
            this.loading = false
        },
        filterRegistrations: function (debounce = false) {
            const filter = () => {
                this.registrations = this.allRegistrations.filter(registration => {  
                    if (this.filters.parent !== null) {
                        if (this.filters.parent) {
                            if (registration.parent) {
                                return false
                            }
                        } else {
                            if (!registration.parent) {
                                return false
                            }
                        }
                    }

                    if (this.filters.id.length &&
                        registration._id.toUpperCase().indexOf(this.filters.id.toUpperCase()) === -1) {
                            return false
                    }
                    
                    if (this.filters.confirmationNumber.length &&
                        (!registration.confirmationNumber ||
                        registration.confirmationNumber.toUpperCase().indexOf(this.filters.confirmationNumber.toUpperCase()) === -1)) {
                            return false
                    }

                    if (this.filters.byRegistrantType && this.filters.byRegistrantType.length > 0 ) {
                        if(this.filters.byRegistrantType.includes(registration.type._id)){
                            return true
                        }
                        return false
                    }

                    if (this.filters.status && !(this.filters.status.includes('all') || this.filters.status.includes(registration.status))) {
                        return false
                    }

                    if (this.filters.paymentMethod &&
                        registration.paymentMethod !== this.filters.paymentMethod) {
                            return false
                    }

                    if(this.filters.paymentStatus){
                        if(registration.parent){
                            if(( registration.parent.paid <= 0 || registration.parent.paid >= registration.parent.total) &&  this.filters.paymentStatus=='partial_payment'){  //partial paid
                                return false;
                            }
                            if(( registration.parent.paid == 0 || (registration.parent.paid > 0 && registration.parent.paid < registration.parent.total) ) &&  this.filters.paymentStatus=='fully_paid'){                //full paid
                                return false;
                            }
                            if(registration.parent.paid > 0 && this.filters.paymentStatus=='not_paid'){   //not paid
                                return false;
                            }
                        }else{
                            if(( registration.paid <= 0 || registration.paid >= registration.total) &&  this.filters.paymentStatus=='partial_payment'){  //partial paid
                                return false;
                            }
                            if(( registration.paid == 0 || (registration.paid > 0 && registration.paid < registration.total) ) &&  this.filters.paymentStatus=='fully_paid'){                //full paid
                                return false;
                            }
                            if(registration.paid > 0 && this.filters.paymentStatus=='not_paid'){   //not paid
                                return false;
                            }
                        }
                    }
                    
                    if (this.filters.fullOrPartial &&
                        registration.paymentType !== this.filters.fullOrPartial) {
                            return false
                    }
                    
                    if (this.filters.paymentMade) {
                        if(!registration.parent){
                            if (
                                (this.filters.paymentMade === 'yes' && registration.paid <= 0) ||
                                (this.filters.paymentMade === 'no') && registration.paid > 0) {
                                    return false
                            }
                        }else{
                            if (
                                (this.filters.paymentMade === 'yes' && registration.parent.paid <= 0) ||
                                (this.filters.paymentMade === 'no') && registration.parent.paid > 0) {
                                    return false
                            }
                        }
                    }
    
                    return true
                })
                this.filterTotal = Object.values(this.filters).filter(item=>{if(item!=null && item!='' && item!=undefined)return 1});
                this.getTotals()
            }

            if (debounce) {
                let delay = _.debounce(() => {
                    filter()
                }, 300)
                delay()
            } else {
                filter()
            }
        },
        getTotals: function () {
            const totals = {
                net: 0,
                deposit: 0,
                balance: 0,
                charges: 0,
                discounts: 0,
                activity: {},
                unsatisfiedMinimumCount:0
            }

            this.totals = totals
            this.registrations.forEach(registration => {
                if(!registration.parent){
                    const total = parseInt(registration.total)
                    const paid = parseInt(registration.paid)
                    let balance = total - paid
                    
                    // if (balance < 0) {
                    //     balance = 0
                    // }

                    if (!Number.isNaN(total)) {
                        totals.net += total
                    }
                    
                    if (!Number.isNaN(paid)) {
                        totals.deposit += paid
                    }
                    
                    if (!Number.isNaN(balance)) {
                        totals.balance += balance
                    }

                    totals.charges += registration.totalCharges
                    totals.discounts += registration.totalDiscounts
                }
                //For custom field new changes
                // registration.fields.map(field=>{
                //     let typeField = registration.type.fields.find( ({ _id }) => _id === field._id )
                //         field.showTotalsOnReport = typeField.showTotalsOnReport
                //         field.showCount = typeField.showCount
                //         return field
                // })
                registration.fields.forEach(field => {
                    if (field.showTotalsOnReport) {
                        let value = 0
                        if (field.showCount) {
                            value = 1
                        } else {
                            let newValue = parseInt(field.value)
                            if (!Number.isNaN(newValue)) {
                                value = newValue
                            }
                        }

                        if (!totals[field._id]) {
                            totals[field._id] = value
                        } else {
                            totals[field._id] += value
                        }
                    }
                })

                this.activities.map(activity=>{
                    if(!totals.activity[activity._id]){
                        totals.activity[activity._id] = 0;
                    }

                    if( [...registration.registeredActivities,...registration.fieldBasedActivities].map(activity=>
                    activity._id).includes(activity._id) ){
                        totals.activity[activity._id] = totals.activity[activity._id] + 1
                    }
                })

                if(registration.type.minimumCount && registration.registrantsCount){
                    let unsatisfied = (registration.type.minimumCount - registration.registrantsCount)
                    totals.unsatisfiedMinimumCount += unsatisfied > 0 ? unsatisfied : 0;
                }

            })
            this.totals = totals
        },
        downloadReports: async function () {
            console.log('@@memorySizeOf2',this.memorySizeOf({
                customFields: this.customFields,
                registrations: this.registrations,
                activities: this.activities,
                totals: this.totals,
                isParent: this.isParent,
                eventId: this.eventId
            }))
            this.downloading = true
            try {
                const response = await http.post('/api/registrations/get-reports', {
                    // customFields: this.customFields,
                    registrations: this.registrations.map(reg => reg._id),
                    // activities: this.activities,
                    totals: this.totals,
                    isParent: this.isParent,
                    eventId: this.eventId
                }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'reports.xlsx', '	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list')
            }
            this.downloading = false
        },
        memorySizeOf: function(obj) {
            var bytes = 0;

            function sizeOf(obj) {
                if(obj !== null && obj !== undefined) {
                    switch(typeof obj) {
                    case 'number':
                        bytes += 8;
                        break;
                    case 'string':
                        bytes += obj.length * 2;
                        break;
                    case 'boolean':
                        bytes += 4;
                        break;
                    case 'object':
                        var objClass = Object.prototype.toString.call(obj).slice(8, -1);
                        if(objClass === 'Object' || objClass === 'Array') {
                            for(var key in obj) {
                                if(!obj.hasOwnProperty(key)) continue;
                                sizeOf(obj[key]);
                            }
                        } else bytes += obj.toString().length * 2;
                        break;
                    }
                }
                return bytes;
            };

            function formatByteSize(bytes) {
                if(bytes < 1024) return bytes + " bytes";
                else if(bytes < 1048576) return(bytes / 1024).toFixed(3) + " KiB";
                else if(bytes < 1073741824) return(bytes / 1048576).toFixed(3) + " MiB";
                else return(bytes / 1073741824).toFixed(3) + " GiB";
            };

            return formatByteSize(sizeOf(obj));
        },
        download: async function (file) {
            try {
                const response = await http.get(this.baseUrl + file.path, {
                    responseType: 'arraybuffer'
                })
                download(response.data, file.name)
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list', e)
            }
        },
    },
    filters: {
        formatDate: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
        deposit: (registration) => {
            let deposit = parseInt(registration.total) - parseInt(registration.paid)

            if (deposit < 0) {
                deposit = 0
            }
            
            return deposit
        },
        avlRegistrantCount: (value)=>{
            if(value.type.groupCount){
                let hasRegistrant = Object.values(value.type.groupCount).reduce((total,item)=>parseInt(total)+parseInt(item))
                return (hasRegistrant+1) - (value.registrants.length + 1 )
            }else{
                return '';
            }
        }
    }
}
</script>